import { Pipe, PipeTransform } from "@angular/core";
import { BootstrapService } from "../modules/bootstrap/bootstrap.service";
import { buildUrlWithFacility } from "../common/facility";

@Pipe({
  name: "buildUrlWithFacility",
  standalone: false
})
export class BuildUrlWithFacilityPipe implements PipeTransform {
  constructor(private bootstrap: BootstrapService) {}

  transform(value: string): string {
    return buildUrlWithFacility(this.bootstrap.getCurrentFacilityCode(), value);
  }
}
